export default __webpack_public_path__ + "static/media/java.ef0352c6.svg";